module.exports = global["jQuery"] = require("-!/home/prod/web/fuib-dev/src/public/portal/node_modules/jquery/dist/jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/dist/jquery.js
 ** module id = 4
 ** module chunks = 0
 **/